(function () {
  'use strict';

  var section = document.querySelector('.odms26summer-header');
  if (!section) return;

  var cta = section.querySelector('.odms26summer-header__cta');
  var ctaExpired = section.querySelector('.odms26summer-header__cta-expired');

  // Main CTA: smooth-scroll to the schedule section.
  if (cta) {
    cta.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation(); // prevent Prestige theme.js from hijacking the scroll
      var target = document.getElementById('Odms-Stundenplan-Section');
      if (target) target.scrollIntoView({ behavior: 'smooth' });
    });
  }

  // Expired state: once the campaign end date has passed, switch to "past" messaging.
  var expireStr = section.getAttribute('data-expire-date');
  if (expireStr) {
    var parts = expireStr.split('.');
    var expireDate = new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));
    var now = new Date();
    now.setHours(0, 0, 0, 0);

    if (now >= expireDate) {
      var subtext = section.querySelector('.odms26summer-header__subtext');
      if (subtext) {
        subtext.innerHTML =
          'Digital Marketing School verpasst? Sicher dir das Komplettpaket und erhalte alle Aufzeichnungen bereits vergangener Sessions sowie dein OMR Abschlusszertifikat.'
      }
      var badge = section.querySelector('.odms26summer-header__expired-badge');
      if (badge) badge.style.display = 'flex';
      if (cta) cta.style.display = 'none';
      if (ctaExpired) ctaExpired.style.display = 'flex';
    } 
  }

  // Native share (deals button, mobile only).
  var dealsBtn = section.querySelector('.odms26summer-header__deals-button');
  if (dealsBtn) {
    dealsBtn.addEventListener('click', function () {
      if (typeof pushEventToDl === 'function') {
        pushEventToDl('shareButtonClick', window.location.ref, '');
      }
      if (navigator.share) {
        navigator
          .share({
            title: 'Gemeinsam lernen bringt doppelt Spaß 🙌 ',
            text: 'Erweitere dein Marketing-Wissen in acht praxisnahen Online-Sessions. 29 € je Einzelsession, 199 € für’s Komplettpaket mit Zertifikat und Aufzeichnungen. Wofür entscheidest du dich?',
            url: window.location.href,
          })
          .catch(function () {});
      }
    });
  }
})();
